import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  UserGroupIcon,
  ChevronRightIcon,
  MagnifyingGlassIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  EnvelopeIcon,
  PhoneIcon
} from '@heroicons/react/24/outline';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const TeamDirectory = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [teams, setTeams] = useState([]);
  const [expandedTeams, setExpandedTeams] = useState(new Set());

  useEffect(() => {
    // Sample team data with hierarchical structure
    const teamData = [
      {
        id: 1,
        name: "Cardiology Team",
        department: "Cardiology",
        teamLead: {
          id: 1,
          name: "Dr. Anita Reddy",
          position: "Chief Cardiologist",
          image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=150&h=150&fit=crop&crop=face",
          email: "anita.reddy@apollo.com",
          phone: "+91 98765 43210"
        },
        members: [
          {
            id: 7,
            name: "Dr. Suresh Kumar",
            position: "Cardiac Surgeon",
            image: "https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=150&h=150&fit=crop&crop=face",
            email: "suresh.kumar@apollo.com",
            phone: "+91 98765 43216",
            level: "senior"
          },
          {
            id: 8,
            name: "Nurse Priya",
            position: "Cardiac Care Nurse",
            image: "https://images.unsplash.com/photo-1594824848402-d2ba4c3e3c65?w=150&h=150&fit=crop&crop=face",
            email: "priya.nurse@apollo.com",
            phone: "+91 98765 43217",
            level: "junior"
          },
          {
            id: 19,
            name: "Tech Ravi",
            position: "Cardiac Technician",
            image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=150&h=150&fit=crop&crop=face",
            email: "ravi.tech@apollo.com",
            phone: "+91 98765 43218",
            level: "junior"
          }
        ],
        description: "Comprehensive cardiac care team specializing in heart conditions and cardiovascular treatments",
        specialization: "Cardiology & Cardiovascular Surgery",
        memberCount: 4
      },
      {
        id: 2,
        name: "Emergency Response Team",
        department: "Emergency Medicine",
        teamLead: {
          id: 9,
          name: "Dr. Rajesh Sharma",
          position: "Emergency Department Head",
          image: "https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=150&h=150&fit=crop&crop=face",
          email: "rajesh.sharma@apollo.com",
          phone: "+91 98765 43219"
        },
        members: [
          {
            id: 2,
            name: "Arjun Singh",
            position: "Nurse Practitioner",
            image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=150&h=150&fit=crop&crop=face",
            email: "arjun.singh@apollo.com",
            phone: "+91 98765 43211",
            level: "senior"
          },
          {
            id: 10,
            name: "Nurse Maya",
            position: "Emergency Nurse",
            image: "https://images.unsplash.com/photo-1594824848402-d2ba4c3e3c65?w=150&h=150&fit=crop&crop=face",
            email: "maya.nurse@apollo.com",
            phone: "+91 98765 43220",
            level: "senior"
          },
          {
            id: 20,
            name: "Paramedic John",
            position: "Emergency Paramedic",
            image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=150&h=150&fit=crop&crop=face",
            email: "john.paramedic@apollo.com",
            phone: "+91 98765 43221",
            level: "junior"
          }
        ],
        description: "24/7 emergency response team handling critical cases and trauma care",
        specialization: "Emergency Medicine & Trauma Care",
        memberCount: 4
      },
      {
        id: 3,
        name: "Diagnostic Lab Team",
        department: "Laboratory Services",
        teamLead: {
          id: 11,
          name: "Dr. Vikram Patel",
          position: "Chief Pathologist",
          image: "https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=150&h=150&fit=crop&crop=face",
          email: "vikram.patel@apollo.com",
          phone: "+91 98765 43222"
        },
        members: [
          {
            id: 3,
            name: "Deepika Joshi",
            position: "Medical Technologist",
            image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=150&h=150&fit=crop&crop=face&auto=format",
            email: "deepika.joshi@apollo.com",
            phone: "+91 98765 43212",
            level: "senior"
          },
          {
            id: 12,
            name: "Ravi Kumar",
            position: "Lab Technician",
            image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=150&h=150&fit=crop&crop=face",
            email: "ravi.kumar@apollo.com",
            phone: "+91 98765 43223",
            level: "junior"
          },
          {
            id: 21,
            name: "Lab Assistant Sita",
            position: "Laboratory Assistant",
            image: "https://images.unsplash.com/photo-1594824848402-d2ba4c3e3c65?w=150&h=150&fit=crop&crop=face",
            email: "sita.lab@apollo.com",
            phone: "+91 98765 43224",
            level: "junior"
          }
        ],
        description: "Advanced diagnostic testing and pathology services team",
        specialization: "Clinical Pathology & Diagnostics",
        memberCount: 4
      },
      {
        id: 4,
        name: "Orthopedic Surgery Team",
        department: "Orthopedics",
        teamLead: {
          id: 4,
          name: "Dr. Rajesh Kumar",
          position: "Chief Orthopedic Surgeon",
          image: "https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=150&h=150&fit=crop&crop=face",
          email: "rajesh.kumar@apollo.com",
          phone: "+91 98765 43213"
        },
        members: [
          {
            id: 13,
            name: "Dr. Kavya Reddy",
            position: "Orthopedic Specialist",
            image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=150&h=150&fit=crop&crop=face",
            email: "kavya.reddy@apollo.com",
            phone: "+91 98765 43225",
            level: "senior"
          },
          {
            id: 14,
            name: "Therapy Assistant Ram",
            position: "Physical Therapist",
            image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=150&h=150&fit=crop&crop=face",
            email: "ram.therapy@apollo.com",
            phone: "+91 98765 43226",
            level: "junior"
          }
        ],
        description: "Specialized team for bone, joint, and musculoskeletal treatments",
        specialization: "Orthopedic Surgery & Joint Care",
        memberCount: 3
      },
      {
        id: 5,
        name: "Rehabilitation Team",
        department: "Rehabilitation",
        teamLead: {
          id: 5,
          name: "Priya Sharma",
          position: "Head Physiotherapist",
          image: "https://images.unsplash.com/photo-1594824848402-d2ba4c3e3c65?w=150&h=150&fit=crop&crop=face",
          email: "priya.sharma@apollo.com",
          phone: "+91 98765 43214"
        },
        members: [
          {
            id: 15,
            name: "Dr. Anil Gupta",
            position: "Rehabilitation Specialist",
            image: "https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=150&h=150&fit=crop&crop=face",
            email: "anil.gupta@apollo.com",
            phone: "+91 98765 43227",
            level: "senior"
          },
          {
            id: 16,
            name: "Therapy Assistant Sita",
            position: "Occupational Therapist",
            image: "https://images.unsplash.com/photo-1594824848402-d2ba4c3e3c65?w=150&h=150&fit=crop&crop=face",
            email: "sita.therapy@apollo.com",
            phone: "+91 98765 43228",
            level: "junior"
          }
        ],
        description: "Comprehensive rehabilitation and physical therapy services",
        specialization: "Physical & Occupational Therapy",
        memberCount: 3
      },
      {
        id: 6,
        name: "Pediatric Care Team",
        department: "Pediatrics",
        teamLead: {
          id: 6,
          name: "Dr. Meera Patel",
          position: "Chief Pediatrician",
          image: "https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=150&h=150&fit=crop&crop=face",
          email: "meera.patel@apollo.com",
          phone: "+91 98765 43215"
        },
        members: [
          {
            id: 17,
            name: "Dr. Sanjay Verma",
            position: "Pediatric Surgeon",
            image: "https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=150&h=150&fit=crop&crop=face",
            email: "sanjay.verma@apollo.com",
            phone: "+91 98765 43229",
            level: "senior"
          },
          {
            id: 18,
            name: "Nurse Sunita",
            position: "Pediatric Nurse",
            image: "https://images.unsplash.com/photo-1594824848402-d2ba4c3e3c65?w=150&h=150&fit=crop&crop=face",
            email: "sunita.nurse@apollo.com",
            phone: "+91 98765 43230",
            level: "senior"
          },
          {
            id: 22,
            name: "Child Specialist Rita",
            position: "Child Psychologist",
            image: "https://images.unsplash.com/photo-1594824848402-d2ba4c3e3c65?w=150&h=150&fit=crop&crop=face",
            email: "rita.child@apollo.com",
            phone: "+91 98765 43231",
            level: "junior"
          }
        ],
        description: "Specialized medical care team for infants, children, and adolescents",
        specialization: "Pediatric Medicine & Child Care",
        memberCount: 4
      }
    ];

    // Simulate loading
    setTimeout(() => {
      setTeams(teamData);
      setLoading(false);
    }, 1000);
  }, []);

  const filteredTeams = teams.filter(team =>
    team.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    team.department.toLowerCase().includes(searchQuery.toLowerCase()) ||
    team.teamLead.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    team.specialization.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const toggleTeamExpansion = (teamId) => {
    const newExpanded = new Set(expandedTeams);
    if (newExpanded.has(teamId)) {
      newExpanded.delete(teamId);
    } else {
      newExpanded.add(teamId);
    }
    setExpandedTeams(newExpanded);
  };

  const handleEmployeeClick = (employeeId) => {
    navigate(`/directory/employee/${employeeId}`);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-apollo-gray">
        <Header />
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-apollo-primary mx-auto mb-4"></div>
            <p className="text-gray-600">Loading team directory...</p>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-apollo-gray">
      <Header />
      
      {/* Page Header */}
      <div className="bg-gradient-to-r from-apollo-primary to-apollo-accent text-white py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <UserGroupIcon className="w-12 h-12 sm:w-16 sm:h-16 mx-auto mb-4 opacity-80" />
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4">Team Directory</h1>
            <p className="text-lg sm:text-xl opacity-90 max-w-2xl mx-auto px-4">
              Meet our specialized medical teams and their hierarchical structure
            </p>
          </div>
        </div>
      </div>

      {/* Search Bar */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-6 mb-6 sm:mb-8">
          <div className="relative max-w-lg mx-auto">
            <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 sm:w-5 sm:h-5 text-gray-400" />
            <input
              type="text"
              placeholder="Search teams, departments, or team leads..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-8 sm:pl-10 pr-4 py-2 sm:py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-apollo-accent focus:border-transparent outline-none transition-all duration-200 text-sm sm:text-base"
            />
          </div>
        </div>

        {/* Teams List */}
        <div className="space-y-6">
          {filteredTeams.map(team => (
            <div
              key={team.id}
              className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden"
            >
              {/* Team Header */}
              <div
                className="p-6 cursor-pointer hover:bg-gray-50 transition-colors"
                onClick={() => toggleTeamExpansion(team.id)}
              >
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">
                  <div className="flex flex-col sm:flex-row sm:items-center space-y-3 sm:space-y-0 sm:space-x-4">
                    {/* Team Lead Image */}
                    <img
                      src={team.teamLead.image}
                      alt={team.teamLead.name}
                      className="w-12 h-12 sm:w-16 sm:h-16 rounded-xl object-cover border-2 border-apollo-accent/20 mx-auto sm:mx-0"
                    />
                    
                    {/* Team Info */}
                    <div className="text-center sm:text-left">
                      <h3 className="text-lg sm:text-xl font-bold text-apollo-primary mb-1">
                        {team.name}
                      </h3>
                      <p className="text-apollo-accent font-medium mb-1 text-sm sm:text-base">
                        {team.department}
                      </p>
                      <p className="text-gray-600 text-sm mb-2">
                        {team.description}
                      </p>
                      <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 text-xs sm:text-sm text-gray-500 space-y-1 sm:space-y-0">
                        <div className="flex items-center justify-center sm:justify-start">
                          <UserGroupIcon className="w-3 h-3 sm:w-4 sm:h-4 mr-1" />
                          <span>{team.memberCount} members</span>
                        </div>
                        <div className="text-center sm:text-left">
                          <span>Led by {team.teamLead.name}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Expand/Collapse Button */}
                  <div className="flex items-center justify-center space-x-2">
                    <span className="text-xs sm:text-sm text-gray-500">
                      {expandedTeams.has(team.id) ? 'Hide' : 'Show'} Members
                    </span>
                    {expandedTeams.has(team.id) ? (
                      <ChevronUpIcon className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400" />
                    ) : (
                      <ChevronDownIcon className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400" />
                    )}
                  </div>
                </div>
              </div>

              {/* Team Members (Expandable) */}
              {expandedTeams.has(team.id) && (
                <div className="border-t border-gray-100 bg-gray-50/50">
                  {/* Team Lead Details */}
                  <div className="p-6 border-b border-gray-100">
                    <h4 className="text-lg font-semibold text-gray-900 mb-4">Team Lead</h4>
                    <div
                      className="flex items-center justify-between p-4 bg-white rounded-xl border border-apollo-accent/20 cursor-pointer hover:shadow-md transition-all duration-200"
                      onClick={() => handleEmployeeClick(team.teamLead.id)}
                    >
                      <div className="flex items-center space-x-4">
                        <img
                          src={team.teamLead.image}
                          alt={team.teamLead.name}
                          className="w-12 h-12 rounded-lg object-cover"
                        />
                        <div>
                          <h5 className="font-semibold text-apollo-primary">
                            {team.teamLead.name}
                          </h5>
                          <p className="text-apollo-accent text-sm">
                            {team.teamLead.position}
                          </p>
                          <div className="flex items-center space-x-3 mt-1">
                            <div className="flex items-center text-xs text-gray-500">
                              <EnvelopeIcon className="w-3 h-3 mr-1" />
                              <span>{team.teamLead.email}</span>
                            </div>
                            <div className="flex items-center text-xs text-gray-500">
                              <PhoneIcon className="w-3 h-3 mr-1" />
                              <span>{team.teamLead.phone}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <ChevronRightIcon className="w-5 h-5 text-gray-400" />
                    </div>
                  </div>

                  {/* Team Members */}
                  <div className="p-4 sm:p-6">
                    <h4 className="text-base sm:text-lg font-semibold text-gray-900 mb-4">Team Members</h4>
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4">
                      {team.members.map(member => (
                        <div
                          key={member.id}
                          className="flex items-center justify-between p-3 sm:p-4 bg-white rounded-xl border border-gray-200 hover:border-apollo-accent/30 cursor-pointer hover:shadow-md transition-all duration-200"
                          onClick={() => handleEmployeeClick(member.id)}
                        >
                          <div className="flex items-center space-x-3">
                            <img
                              src={member.image}
                              alt={member.name}
                              className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg object-cover"
                            />
                            <div className="min-w-0">
                              <h6 className="font-medium text-gray-900 text-sm sm:text-base truncate">
                                {member.name}
                              </h6>
                              <p className="text-xs sm:text-sm text-gray-600 truncate">
                                {member.position}
                              </p>
                              <div className="flex items-center space-x-2 mt-1">
                                <span
                                  className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                                    member.level === 'senior'
                                      ? 'bg-apollo-accent/10 text-apollo-accent'
                                      : 'bg-gray-100 text-gray-600'
                                  }`}
                                >
                                  {member.level}
                                </span>
                              </div>
                            </div>
                          </div>
                          <ChevronRightIcon className="w-3 h-3 sm:w-4 sm:h-4 text-gray-400 flex-shrink-0" />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* No Results */}
        {filteredTeams.length === 0 && (
          <div className="text-center py-12">
            <UserGroupIcon className="w-16 h-16 mx-auto text-gray-400 mb-4" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2">No teams found</h3>
            <p className="text-gray-600">Try adjusting your search terms</p>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default TeamDirectory;
